import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';

export const List = styled.ul`
  position: static;
  padding: 0;
  border: 0;
  background: none;
`;

export const Item = styled.li`
  position: relative;
  padding: 6px 0;
  height: 35px;
  background-color: ${COLORS.transparent};
`;

export const ItemText = styled.div`
  margin: 0px 10px;
  color: ${COLORS.mlbWhite};
  font-size: 15px;
  font-weight: 600;
`;

export const RemoveItemButton = styled.button`
  position: absolute;
  top: 10px;
  right: -5px;
  border: 0;
  background-color: ${COLORS.transparent};
  opacity: 0.65;
  font-size: 12px;
  cursor: pointer;
`;
